import { __assign, __read, __rest } from "tslib";
import React, { useMemo, useRef, useEffect, useState } from 'react';
import { formatScaleLabel } from '@keen.io/charts-utils';
import { Tick, Line } from '../elements';
import { Group } from './ruler.styles';
import RulerLabel from '../ruler-label';
import AxisTitle from '../axis-title.component';
import { generateRuler, rotateLabel } from './utils';
import { Orientation } from '../../types';
var TEXT_CENTER = '0.32em';
var Ruler = function (_a) {
    var scale = _a.scale, x = _a.x, y = _a.y, tickPadding = _a.tickPadding, orientation = _a.orientation, tickSize = _a.tickSize, stroke = _a.stroke, labels = _a.labels, title = _a.title, color = _a.color, scaleSettings = _a.scaleSettings, axisTitle = _a.axisTitle, labelDimension = _a.labelDimension;
    var groupElement = useRef(null);
    var _b = __read(useState({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
    }), 2), groupBox = _b[0], setGroupBox = _b[1];
    useEffect(function () {
        if (groupElement.current) {
            var bbox = groupElement.current.getBBox();
            setGroupBox(bbox);
        }
    }, [groupElement, x, y, axisTitle]);
    var enabled = labels.enabled, typography = labels.typography, radiusAngle = labels.radiusAngle;
    var _c = generateRuler({
        x: x,
        y: y,
        scale: scale,
        scaleSettings: scaleSettings,
        orientation: orientation,
        tickSize: tickSize,
    }), line = _c.line, ticks = _c.ticks, ticksPrecision = _c.ticksPrecision;
    var fontColor = typography.fontColor, rest = __rest(typography, ["fontColor"]);
    var textPosition = useMemo(function () {
        return orientation === Orientation.HORIZONTAL
            ? {
                dy: tickPadding + tickSize,
                dx: 0,
            }
            : {
                dx: -Math.abs(tickPadding + tickSize),
                dy: TEXT_CENTER,
            };
    }, [orientation, tickPadding, tickSize]);
    var _d = rotateLabel(orientation, radiusAngle, tickPadding, tickSize), anchor = _d.anchor, radius = _d.radius, translateX = _d.translateX, translateY = _d.translateY;
    return (React.createElement(React.Fragment, null,
        React.createElement(Group, { color: fontColor, style: __assign({}, rest), ref: groupElement, "data-testid": "ruler-" + orientation },
            React.createElement(Line, __assign({}, line, { color: color, stroke: stroke })),
            ticks.map(function (_a, idx) {
                var x = _a.x, y = _a.y, size = _a.size, text = _a.text;
                return (React.createElement(Tick, { key: idx, x: x, y: y, size: size, color: color, orientation: orientation }, enabled && text !== undefined && (React.createElement("g", { textAnchor: anchor, transform: "translate(" + translateX + ", " + translateY + ") rotate(" + radius + ")" },
                    React.createElement(RulerLabel, __assign({ orientation: orientation, maxDimension: labelDimension }, textPosition), formatScaleLabel(text, scaleSettings, ticksPrecision))))));
            })),
        axisTitle && (React.createElement(AxisTitle, { titleSettings: title, orientation: orientation, line: line, groupBox: groupBox }, axisTitle))));
};
export default Ruler;
